import { render, staticRenderFns } from "./ModalSubmit.vue?vue&type=template&id=dc265ed0&"
import script from "./ModalSubmit.vue?vue&type=script&lang=js&"
export * from "./ModalSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports